import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useCategories } from '@/hooks/categories/useCategories';
import { Skeleton } from '@/components/ui/skeleton';

interface ProfessionnelTypeStepProps {
  onComplete: (data: { typeEvenement: string }) => void;
}

// Mapping des emojis pour les évènements professionnels
const eventEmojis: { [key: string]: string } = {
  'séminaire': '📊',
  'team building': '🤝',
  'soirée': '🎉',
  'cocktail': '🍸',
  'afterwork': '🏢',
  'brunch': '🥐',
  'petit-déjeuner': '☕',
  'déjeuner': '🍽️',
  'repas': '🍽️',
  'atelier': '👨‍🍳',
  'dégustation': '🍷',
  'salon': '🏪',
  'stand': '🎪',
  'évènement presse': '📰',
  'influenceurs': '📱',
  'remise de prix': '🏆',
  'récompenses': '🏆',
  'intégration': '🚀',
  'week-end': '🎯',
  'journée': '📅'
};

const getEventEmoji = (title: string): string => {
  const lowerTitle = title.toLowerCase();
  for (const [key, emoji] of Object.entries(eventEmojis)) {
    if (lowerTitle.includes(key)) {
      return emoji;
    }
  }
  return '🏢'; // Emoji par défaut pour professionnel
};

export const ProfessionnelTypeStep = ({ onComplete }: ProfessionnelTypeStepProps) => {
  const [autreType, setAutreType] = useState('');
  
  // Récupérer les évènements professionnels de la base de données
  const { categories, isLoading } = useCategories(false, 'professionnel');

  if (isLoading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-4 w-64 mx-auto" />
        <div className="grid grid-cols-1 gap-3">
          {[1, 2, 3, 4].map(i => (
            <Skeleton key={i} className="h-16 w-full rounded-lg" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-sm text-muted-foreground text-center">
        Sélectionnez le type d'évènement souhaité.
      </div>
      
      <div className="grid grid-cols-1 gap-3">
        {categories?.map((category) => (
          <Button
            key={category.id}
            onClick={() => onComplete({ typeEvenement: category.title })}
            variant="outline"
            className="min-h-16 h-auto py-3 px-4 flex flex-col items-center justify-center gap-0.5 whitespace-normal text-center hover:bg-primary/5"
          >
            <span className="font-medium">
              {category.title}
            </span>
            <span className="text-xs text-muted-foreground">{category.description}</span>
          </Button>
        ))}
      </div>
      
      <div className="space-y-2">
        <Input
          placeholder="Autre (précisez)"
          value={autreType}
          onChange={(e) => setAutreType(e.target.value)}
        />
        <Button
          onClick={() => onComplete({ typeEvenement: autreType })}
          disabled={!autreType.trim()}
          variant="outline"
          className="w-full"
        >
          Valider "Autre"
        </Button>
      </div>
    </div>
  );
};